<template>
  <div class='rightPage'>
    <v-search :formContent='formContent' :SearchForm='SearchForm' :inline='true' :optareBtn='optareBtn'
              :treePathObj='treePathObj' @resetFn='resetFn' @confirmFn='getListFns' @searchFn='getListFns'
              @addCarrierFn='addCarrierFn' @delCarrierFn='delCarrierFn' class='vSearch'>
    </v-search>

    <div class='componentPage'>
      <tablePage ref='table' :tableData='tableData' :loading='loading' :getCarrierStatus='getCarrierStatus'
                 @detailFn='detailFn' @transportFn='transportFn' @rowDel='rowDel' @choozeTableFn='choozeTableFn'
                 @getListFn='getListFns' />
      <Pagination class='pagination' :total='total' :page.sync='SearchForm.iDisplayStart'
                  :limit.sync='SearchForm.iDisplayLength' @pagination='getListFns'></Pagination>
    </div>
    <!-- 新增监测点 -->
    <CarrierDia :isShow.sync='isShow' :title='title' :getCarrierType='getCarrierType'
                :getCarrierStatus='getCarrierStatus' ref='CarrierDia' />
    <!-- 报警触发 -->
    <!--<alarmDialog :detailObj='detailObj' :isAlarm.sync='isAlarm' :title='title' :loading='alarmLoading'-->
    <!--             :tableData='alarmTableData' :total='alarmTotal' :disabledLoad='disabledLoad'-->
    <!--             :choozeTable='choosedTrigger'-->
    <!--             @getList='getListFns' />-->

    <!-- 传感器详情 -->
    <ProbeDetail></ProbeDetail>
    <transport-code></transport-code>
    <!-- 通知对象模态框 -->
    <NoticeDialog
      :isShow="isShowNoticeObject"
      :isBatch="true"
      :choozeTableData="choozeTableData"
      :type="getCarrierType.id"
      @close="isShowNoticeObject = false"
    ></NoticeDialog>

    <!-- 增加无效规则模态框 -->
    <ReletedRuleDialog
      v-if="isShowReletedRuleDialog"
      :isShow="isShowReletedRuleDialog"
      :choozeTableData="choozeTableData"
      @close="isShowReletedRuleDialog = false">
    </ReletedRuleDialog>

  </div>
</template>

<script>
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import { alarmTriggerList } from '@/api/modules/alarm.js'
import { SET_STATUS_FN, stautsIconArray } from '@/utils/setIcon.js'
import ProbeDetail from '@/components/dialog/probeDetail/ProbeDetail'
import tablePage from './Table.vue'
import CarrierDia from '../dialog/AddCarrierDia.vue'
import alarmDialog from '../dialog/AlarmDialog.vue'
import { carrierList, carrierShareCarrierType, carrierShareParam, displayDelete } from '@/api/modules/carrier.js'
import { carrierDetail } from '@/utils/winDetail'
import TransportCode from '@/components/TransportCode/TransportCode'
import { getIsGuide } from '@/utils/guide'
import { mockCarrierList } from '@/common/driver/modules/monitor/mock'
import NoticeDialog from '../dialog/NoticeDialog.vue'
import ReletedRuleDialog from '@/pages/abnormal/invalidRule/component/ReletedRuleDialog.vue'

export default {
  mixins: [getAllTreePath],
  components: {
    tablePage,
    CarrierDia,
    alarmDialog,
    ProbeDetail,
    TransportCode,
    NoticeDialog,
    ReletedRuleDialog
  },
  computed: {
    disabledLoad: {
      get: function () {
        return this.alarmTotal <= this.alarmTableData.length
      },
      set (val) {
        return val
      }
    },
    isSysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      return currentUser.sysScope && currentUser.sysAdmin
    }
  },
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'integration.name_of_monitoring_point',
          type: 'input',
          paramsName: 'carrierName'
        },
        {
          id: 2,
          text: 'public.status',
          type: 'select',
          paramsName: 'status',
          selectParam: [],
          isChooze: true
        },
        {
          id: 3,
          text: 'public.is_abnormal',
          type: 'select',
          paramsName: 'isEx',
          selectParam: [
            {
              value: '',
              label: 'public.please'
            },
            {
              value: '0',
              label: 'public.btn_no'
            },
            {
              value: '1',
              label: 'public.btn_yes'
            }
          ],
          isChooze: false
        }
      ],
      SearchForm: {
        status: null,

        isEx: null,
        iDisplayStart: 0,
        iDisplayLength: 15,
        carrierName: null
      },
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['delRange'],
          text: 'business.add_carrier',
          method: 'addCarrierFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['delRange'],
          text: 'business.del_carrier',
          method: 'delCarrierFn'
        }
      ],
      total: 0,
      loading: false,
      tableData: [],
      title: '',
      isShow: false,
      getCarrierType: {},
      getCarrierStatus: [],
      stautsIconArray: ['iconfont icon-yunhang', 'iconfont icon-beiyong', 'iconfont icon-baofei', 'iconfont icon-daixiugai', 'iconfont icon-chushuang'],
      choozeTableData: [],

      // 报警触发
      // 报警触发
      alarmLoading: false,
      alarmTableData: [],
      alarmTotal: 0,
      dioForm: {
        iDisplayStart: 0,
        iDisplayLength: 13,
        name: '',
        scopeId: ''
      },
      isAlarm: false,
      detailObj: {},
      choosedTrigger: [],

      isShowNoticeObject: false,
      isShowReletedRuleDialog: false
    }
  },
  async mounted () {
    await this.getCarrierTypeFn()
    this.SearchForm = { ...this.SearchForm, ...this.$route.query }
    if (getIsGuide()) {
      this.tableData = mockCarrierList()
    } else {
      await this.getListFns()
    }

    if (!this.isSysAdmin) {
      const firstNode = this.$store.state.SchemaTree && this.$store.state.SchemaTree[0]
      if (firstNode) {
        this.treePathObj = firstNode.label
        this.SearchForm.scope = firstNode.scopeId
      }
    }
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })

    window.getList = this.getListFns.bind(this)
  },
  methods: {
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.scene = null
        this.SearchForm.scope = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.scene = null
        this.SearchForm.scope = row.scopeId
      } else {
        this.SearchForm.scope = null
        this.SearchForm.scene = row.sceneId
      }
      this.getListFns()
    },
    getCarrierTypeFn () {
      const P1 = carrierShareCarrierType({ typeCode: this.$route.name })
      const P2 = carrierShareParam({
        code: 'carrier_status_item',
        type: 0
      })
      return new Promise((resolve, reject) => {
        Promise.all([P1, P2]).then(array => {
          this.getCarrierType = array[0].result
          // 1. 先获取原始数组
          const originalArray = SET_STATUS_FN(array[1].result, stautsIconArray, 'carrier.', true)


          //  this.formContent[1].selectParam = this.getCarrierStatus = SET_STATUS_FN(array[1].result, stautsIconArray, 'carrier.', true)
         // console.log('this.formContent[1].selectParam=', this.formContent[1].selectParam)

          const formattedArray = originalArray.map(item => {
            return {
              ...item,       // 展开原有属性（如 label, icon 等）
              value: parseInt(item.code) // 将 code 的值赋给 value
            }
          })

          // 3. 将处理后的数组赋值给 formContent 和 getCarrierStatus
          this.formContent[1].selectParam = this.getCarrierStatus = formattedArray

          console.log('this.formContent[1].selectParam=', this.formContent[1].selectParam)
          /** 只给详情使用 */
          sessionStorage.setItem('getCarrierStatus', JSON.stringify(this.getCarrierStatus))
          sessionStorage.setItem('getCarrierType', JSON.stringify(this.getCarrierType))

          resolve()
        })
      })
    },
    getListFns () {
      this.loading = true
      carrierList(this.SearchForm, this.getCarrierType.id)
        .then(({
          result,
          pageInfo
        }) => {
          this.tableData = result
          this.total = pageInfo.total
        })
        .catch(() => {
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetFn () {
      this.SearchForm = {
        status: null,
        tag: null,
        isEx: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      if (!this.isSysAdmin) {
        const firstNode = this.$store.state.SchemaTree && this.$store.state.SchemaTree[0]
        if (firstNode) {
          this.treePathObj = firstNode.label
          this.SearchForm.scope = firstNode.scopeId
        }
      }
      this.getListFns()
    },
    choozeTableFn (row) {
      this.choozeTableData = row
    },
    /** 新增监测点 */
    addCarrierFn () {
      this.isShow = true
      this.title = $t('integration.add_mount')
      this.$nextTick(() => {
        this.$refs.CarrierDia.clearValidate()
      })
    },
    /** 监测点删除 */
    delCarrierFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const id = this.choozeTableData.map(item => item.id).join(',')
      this.$confirm(this.$t('messageTitle.DeleteToContinue'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          displayDelete({ id }, this.getCarrierType.id).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFns()
          })
        })
        .catch(() => {
        })
    },
    /** 单条删除 */
    rowDel (row) {
      this.$confirm(this.$t('messageTitle.DeleteToContinue'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          displayDelete({ id: row.id }, this.getCarrierType.id).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFns()
          })
        })
        .catch(() => {
        })
    },
    /** 报警设置 拿去之前的东西 */
    alarmSetingFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))

      /** 相同范围下 */
      const flag = this.choozeStatus('sceneId')
      if (flag) return this.$message.warning(this.$t('messageTitle.SelectACarrierInTheSameRange').toString())

      this.isAlarm = true
      this.dioForm.iDisplayStart = 0

      this.title = $t('integration.alarm_trigger_setting')
      this.scopeName = { ...this.choozeTableData[0] }

      this.detailObj = this.scopeName
      this.scopeName.id = this.choozeTableData.map(item => item.id)

      this.alarmTableData = []

      this.getListFn()
    },
    /** 获取报警触发列表 */
    getListFn () {
      this.alarmLoading = true
      this.dioForm.scopeId = this.scopeName.sceneId

      alarmTriggerList(this.dioForm)
        .then(({
          result,
          pageInfo
        }) => {
          if (result.length > 0) {
            this.alarmTableData = this.alarmTableData.concat(result)
          } else {
            this.alarmTableData = result
          }
          this.alarmTotal = pageInfo.total
          this.$nextTick(() => {
            this.choosedTrigger = this.choozeTableData.length > 1 ? [] : this.choozeTableData.length && this.choozeTableData[0].alarmTriggerList
          })
        })
        .finally(() => {
          this.alarmLoading = false
        })
    },
    // 传给子级调用
    getDioform () {
      return this.dioForm
    },
    /**
     *
     * @param {传入的属性值} str
     */
    choozeStatus (str) {
      return this.choozeTableData.some(item => {
        return item[str] !== this.choozeTableData[0][str]
      })
    },
    /** 详细  第多少版了  */
    detailFn (row) {
      carrierDetail(row.id, row.keycode, row.typeId)
    },
    // 批量报警触发开关 2023 07 04
    alarmTriggerSwitch () {
      if (this.choozeTableData.length) {
        for (let i = 1; i < this.choozeTableData.length; i++) {
          if (this.choozeTableData[i].sceneId !== this.choozeTableData[0].sceneId) {
            this.$message.warning($t('integration.please_select_the_same_customer'))
            return
          }
        }
      } else {
        return this.$message.warning($t('integration.please_select_a_monitoring_point'))
      }

      if (this.choozeTableData.some(item => item.alarmBind !== 1)) {
        return this.$message.warning($t('integration.please_select_a_monitoring_point_for_the_associated_trigger'))
      }

      const ids = this.choozeTableData.map(item => item.id)

      bus.$emit('alarmSwitchDialog', {
        event: 0,
        carrierIds: ids,
        sceneId: this.choozeTableData[0].sceneId,
        type: this.getCarrierType.id,
        getList: this.getListFns
      })
    },
    transportFn (row) {
      bus.$emit('transportCode', row)
    },
    // 设备切换通知'
    switchNotice(){
      console.log('getCarrierType=', this.getCarrierType)
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      this.isShowNoticeObject = true
    },
    // 关联无效规则
    showReletedRule(){
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      this.isShowReletedRuleDialog = true
    },
  }
}
</script>

<style lang='scss' scoped>
.rightPage {
  flex: 1;
  padding-right: 15px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;

  .vSearch {
    position: relative;
  }

  .componentPage {
    flex: 1;
    height: calc(100% - 50px);

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}

</style>
